import { EmoticonOutlineIcon } from './EmoticonOutlineIcon';

/**
 * author: Google
 * id 69AAECAA-0B17-4C53-8345-4F172B7FEF50
 * name emoticon-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-outline.svg
 * tags
 * - Emoji 
 */
export const SmileyOutlineIcon = EmoticonOutlineIcon;
export default SmileyOutlineIcon